import type { FileHealth } from '../../engine/core/types';

export function HealthPanel({ health }: { health: FileHealth }): React.JSX.Element {
  return (
    <section className="analysis-panel health-panel" aria-labelledby="health-title">
      <div className="panel-heading"><h2 id="health-title">File Health</h2><span className="mono label">{health.model}</span></div>
      <div className="health-panel__body">
        <div className="health-ring" aria-label={`Overall file health ${health.overall} out of 100`}>
          <svg className="health-ring__chart" viewBox="0 0 44 44" aria-hidden="true">
            <circle className="health-ring__track" cx="22" cy="22" r="18" pathLength="100" />
            <circle className="health-ring__value" cx="22" cy="22" r="18" pathLength="100" strokeDasharray={`${health.overall} ${100 - health.overall}`} />
          </svg>
          <div className="health-ring__label"><strong>{health.overall}</strong><span>/ 100</span></div>
        </div>
        <dl className="health-dimensions">
          {health.dimensions.map((dimension) => (
            <div key={dimension.key}>
              <dt>{dimension.label}</dt>
              <dd><strong>{dimension.score}</strong> / 100 <span className="health-label">{dimension.status}</span><span className={`health-status health-status--${dimension.status}`} aria-hidden="true" /></dd>
            </div>
          ))}
        </dl>
      </div>
      <details className="health-method"><summary>How the score is calculated</summary><p>{health.explanation}</p></details>
    </section>
  );
}
